import React from 'react';
interface CTAButtonProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  fullWidth = false,
  href
}: CTAButtonProps) {
  const classes = `
    bg-gradient-to-r from-[#D4A843] via-[#FF8C00] to-[#D4A843] text-[#0A0A0A] hover:from-[#FF8C00] hover:via-[#D4A843] hover:to-[#FF8C00]
    font-extrabold text-lg md:text-xl py-4 px-8 rounded-xl
    transition-all duration-300 transform hover:scale-105
    shadow-[0_0_25px_rgba(212,168,67,0.4),0_0_50px_rgba(255,140,0,0.2)] hover:shadow-[0_0_35px_rgba(255,140,0,0.6),0_0_70px_rgba(212,168,67,0.3)]
    border-2 border-[#D4A843]/50
    flex items-center justify-center text-center
    ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
    ${className}
  `;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-283">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={`${classes} items-center justify-center`} data-id="element-284">
      {children}
    </button>;
}